import React, { Fragment } from "react";

import Typography from '@mui/material/Typography';
import CancelIcon from "@mui/icons-material/Cancel";
import { Controller } from "react-hook-form";
import { FormControl, InputLabel, Select, OutlinedInput, Box, Chip, MenuItem, Switch, ListItemText } from "@mui/material";

const MultiSelectWithChips = (props) => {

    return (
        <Fragment>
            <FormControl sx={{ mt: 1, width: 300 }}>
                <InputLabel>{props.label}</InputLabel>
                <Controller
                    name={props.name}
                    control={props.control}
                    defaultValue=""
                    // {...register("gradesSelected")}
                    render={({ field: { onChange, value } }) => (
                        <Select
                            multiple
                            //defaultValue={0}
                            style={{ marginTop: '0'}}
                            MenuProps={props.MenuProps}
                            name={props.name}
                            value={props.infoSelected}
                            label={props.label}
                            input={<OutlinedInput label={props.label} />}
                            onChange={props.onChange}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                    {selected.map((value) => (
                                        (!props.infoNASelected || value==='N/A') &&
                                        <Chip
                                            key={value}
                                            label={value}
                                            deleteIcon={
                                                <CancelIcon
                                                    onMouseDown={(event) => event.stopPropagation()}
                                                />
                                            }

                                            onDelete={(e) => props.handleChipDelete(e, value, props.setinfoSelected)}

                                        />
                                    ))}
                                </Box>
                            )}
                        >

                            {// no select all option
                            (props.items.indexOf('Select All') === -1) && props.items.map((item) => (
                                <MenuItem value={item} key={item} >
                                    <Switch checked={((props.infoSelected) && (props.infoSelected.indexOf(item) > -1) && (!props.infoNASelected)) || (item === 'N/A' && props.infoNASelected)} />
                                    {<ListItemText primary={item} />}
                                </MenuItem>
                            ))}

                             {// select all option present
                            (props.items.indexOf('Select All') !== -1) && props.items.map((item) => (
                                <MenuItem value={item} key={item} >
                                    <Switch checked={(((props.infoSelected) && (props.infoSelected.indexOf(item) > -1) || ((props.infoSelected) && props.infoSelected.indexOf('Select All')!== -1 && item !== 'N/A'))) 
                                    && (props.infoSelected.indexOf('N/A') === -1 || (props.infoNASelected &&item === 'N/A' ))} />
                                    {<ListItemText primary={item} />}
                                </MenuItem>
                            ))}

                        </Select>

                    )}
                />
            </FormControl>
            <Typography variant="inherit" color="error.main">
                {props.errors?.message}
            </Typography>
        </Fragment>
    );
}
export default MultiSelectWithChips;